import React from 'react';
import './Dropdown.less';
import PolygonIcon from '../../images/polygon_icon.png'

class Dropdown extends React.Component {
    static defaultProps = {
        title:  "Dropdown",
        selections: [{text: "Option", value: 1}],
        onSelected: function(){},
        onChange: function(){},
        value: "",
    };

    constructor(props) {
        super(props);
        this.state = {
            tempFilter: "",
            dropDownOpen: false,
            selectedIndex: this.getSelectedIndex(this.props.selections, this.props.value),
        };        
    }

    getSelectedIndex(selections, value){
        selections.forEach((tag, index) => {
            if(tag.value === value){
                return index;
            }
        });

        return 0;
    }
    
    setTag(newTag, idx){        
        if(newTag != null){
            
            this.setState({dropDownOpen: false, selectedIndex: idx, tempFilter: ""}); 
            this.props.onChange(newTag.value);
        }
    }

    filterList(e)
    {        
        if (e.code.startsWith("Key"))
        {
            var newfilter = this.state.tempFilter + "" + e.key
            this.setState({tempFilter: newfilter});
        }
        else if (e.code === "Backspace")
        {
            this.setState({tempFilter: ""});
        }
    }

    render() {
        const state = this.state;
        const props = this.props;
        var tempFilter = this.state.tempFilter;
        if (!state.dropDownOpen)
            tempFilter = "";
        return (
            <div className={this.props.disabled ? "vithrough_dropdown disabled" : "vithrough_dropdown"}>
                <div className='vithrough_dropdown_container' onKeyDown={(e) => this.filterList(e)} onMouseLeave={() => this.setState({dropDownOpen: false})}>
                    <button 
                        disabled={this.props.disabled}
                        className={state.dropDownOpen ? "armodelviewer_button vithrough_dropdown_button_open" : "armodelviewer_button vithrough_dropdown_button"} 
                        onClick={() => this.setState({dropDownOpen: !state.dropDownOpen})}
                        title={this.props.title}>
                            <label>{props.selections && props.selections[state.selectedIndex] ? state.dropDownOpen ? tempFilter : props.selections[state.selectedIndex].text : ""}</label>
                            <img alt={this.props.title} src={PolygonIcon} className={state.dropDownOpen ? "vithrough_polygon_opened" : "vithrough_polygon_closed"}/>
                    </button>
                    <div className='vithrough_dropdown_elements' style={{visibility: state.dropDownOpen ? "visible" : "hidden"}}>
                        {props.selections.map((tag, idx) => {  

                            if (tempFilter !== "" && tag.text != null && !tag.text.toLowerCase().startsWith(tempFilter.toString().toLowerCase()))
                            {
                                return "";
                            }

                            return  <div className='vithrough_dropdown_element' key={'dropdown_element' + idx}>
                                        <button 
                                        onClick={() => this.setTag(tag, idx)} 
                                        title={tag.text ? tag.text : ""}
                                        disabled={this.props.disabled}>
                                            <label>{tag.text}</label>
                                        </button>
                                    </div>
                        })}
                    </div>
                </div>
            </div>
        );            
    }
}

export default Dropdown;
